import { render } from "./RecaptchaV2.vue?vue&type=template&id=2a6cece9"
import script from "./RecaptchaV2.vue?vue&type=script&lang=js"
export * from "./RecaptchaV2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__